export default {
  id: 'ID',
  name: 'Название',
  objects: 'Объекты',
  type: 'Тип',
  test: 'Тест',
  entries: 'Количество вхождений',
  entriesDetail: 'Вхождения',
  delete: 'Удалить список',
  deleteDetail: 'Удалить',
  enterBothNameId: 'Пожалуйста, заполните Название и ID',
  empty: 'Список пуст',
  duplicate: 'Дублировать',
  update: 'Обновить',
  listItems: 'Список элементов',
  updateItem: 'Обновить элемент'
}
